import * as yup from "yup";

export const WAIT_LIST_INITIAL_VALUES = {
  isCommentActive: false,
  wait_list_comment: "",
  wait_list_no_longer_schedule_with_roles: undefined,
  wait_list_patient_category: undefined,
  wait_list_reason: [],
  wait_list_requires_urgent_placement: false,
};

export const PATIENT_OPTIONS = [
  { label: "New patient with completed DI", value: "di_no_completed" },
  { label: "Established patient", value: "established_patient" },
];
const PATIENT_OPTIONS_VALUES = PATIENT_OPTIONS.map((item) => item.value);

export const CAN_NO_LONGER_SCHEDULE_WITH_ROLES = [
  { checked: true, disabled: true, label: "Intake", value: "BEHAVIORAL_INTAKE" },
  { checked: false, label: "Prescriber", value: "PRESCRIBE" },
  { checked: false, label: "BHS", value: "BEHAVIORAL" },
];

const CAN_NO_LONGER_SCHEDULE_WITH_ROLES_VALUES = CAN_NO_LONGER_SCHEDULE_WITH_ROLES.map(
  (item) => item.value,
);

export const NON_DI_PATIENT_REASONS = [
  { checked: false, label: "No BHS after intake", value: "No BHS after intake" },
  { checked: false, label: "No prescriber after intake", value: "No prescriber after intake" },
  { checked: false, label: "Insurance change", value: "Insurance change" },
  { checked: false, label: "Teens and Kids program", value: "Teens and Kids program" },
  { checked: false, label: "Other", value: "Other" },
];

export const ESTABLISHED_PATIENT_REASONS = [
  { checked: false, label: "Provider departure", value: "Provider departure" },
  { checked: false, label: "Insurance change", value: "Insurance change" },
  { checked: false, label: "Patient request", value: "Patient request" },
  { checked: false, label: "Medication management", value: "Medication management" },
  { checked: false, label: "Teens and Kids program", value: "Teens and Kids program" },
  { checked: false, label: "Other", value: "Other" },
];

const WAIT_LIST_REASON_VALUES = [...NON_DI_PATIENT_REASONS, ...ESTABLISHED_PATIENT_REASONS].map(
  (item) => item.value,
);

export const WAIT_LIST_VALIDATION = yup.object().shape({
  wait_list_comment: yup.string().max(500, "500 character limit"),
  wait_list_no_longer_schedule_with_roles: yup
    .array()
    .nullable()
    .of(yup.string())
    .test("values-in-list", "Please select a valid answer", (values) => {
      if (values === undefined) {
        return true;
      }

      return values.every((value) => CAN_NO_LONGER_SCHEDULE_WITH_ROLES_VALUES.includes(value));
    }),
  wait_list_patient_category: yup
    .string()
    .oneOf(PATIENT_OPTIONS_VALUES)
    .required("Question is required"),
  wait_list_reason: yup
    .array()
    .of(yup.string())
    .test("values-in-list", "Please select a valid answer", (values) => {
      return values.every((value) => WAIT_LIST_REASON_VALUES.includes(value));
    })
    .required("Question is required"),
  wait_list_requires_urgent_placement: yup.bool().required("Question is required"),
});
